/**
 * @Author Morsal
 */
import { CablePuzzleService } from "../services/CablePuzzleService";
import { CablePuzzleModal } from "./CablePuzzleModal";

export class CablePuzzleComponent extends HTMLElement {
    private selections: Record<string, string> = {};
    private locked = false;
    private cablePuzzleService = new CablePuzzleService();

    public connectedCallback(): void {
        this.style.position = "absolute";
        this.style.top = "0";
        this.style.left = "0";
        this.style.zIndex = "999";
        this.attachShadow({ mode: "open" });
        this.render();
        this.setupEvents();
    }

    private render(): void {
        if (!this.shadowRoot) return;
        this.shadowRoot.innerHTML = `
            <style>
                #overlay {
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.50);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-family: Orbitron, sans-serif;
                    color: #00eaff;
                }
                
                .puzzle { 
                position: absolute;
                padding: 30px;
                background: #001a33; 
                border: 2px solid #00eaff; 
                border-radius: 10px; 
                text-align: center;
                }
                
                .row { 
                margin-bottom: 12px; 
                display: flex; 
                justify-content: space-between;
                }
                
                .btn { 
                border: 2px solid #00eaff; 
                padding: 5px 10px; 
                background: black; 
                color: #00eaff; 
                cursor: pointer;
                }

                .btn.selected {
                background: #00eaff;
                color: black;
                box-shadow: 0 0 10px #00eaff;
                font-weight: bold;
                }

                
                .btn:hover { 
                background: #00eaff; 
                color: black; }

                #close-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                background: none;
                color: red;
                border: none;
                font-size: 22px;
                font-weight: bold;
                cursor: pointer;
                z-index: 10;
            }
                #close-btn:hover {
                    color: #ff4c4c;
                }
            </style>

            <div id="overlay">
                <div class="puzzle">
                <button id="close-btn" title="Close">✖</button>
                    <h2>Reconnect the Network Cables</h2>
                    <p>Input the correct port for each color to reestablish the system.<p>
                    ${["red", "blue", "green", "purple"].map(this.createRow).join("")}
                    <div id="result"></div>
                </div>
            </div>
        `;
    }

    private createRow = (color: string): string => {
        return `<div class="row">
                    <span>${color.toUpperCase()} →</span>
                    ${["A", "B", "C"].map(port => `<button class="btn" data-color="${color}" data-port="${port}">${port}</button>`).join("")}
                </div>`;
    };

    private setupEvents(): void {
        const buttons: NodeListOf<Element> | undefined = this.shadowRoot?.querySelectorAll(".btn");
        const result: Element | null | undefined = this.shadowRoot?.querySelector("#result");

        buttons?.forEach(btn => {
            btn.addEventListener("click", async () => {
                if (this.locked) return;
                const color: string = (btn as HTMLElement).dataset.color!;
                const port: string = (btn as HTMLElement).dataset.port!;
                this.selections[color] = port;

                buttons.forEach(b => {
                    const bEl: HTMLElement = b as HTMLElement;
                    if (bEl.dataset.color === color) {
                        bEl.classList.remove("selected");
                    }
                });

                // Voeg selectie toe aan de aangeklikte knop
                (btn as HTMLElement).classList.add("selected");

                if (Object.keys(this.selections).length === 4) {
                    this.locked = true;

                    const isCorrect: boolean = await this.cablePuzzleService.submitPuzzleSolution(this.selections);
                    if (isCorrect) {
                        result!.textContent = "✅ Network repaired!";
                        setTimeout(() => {
                            CablePuzzleModal.closeCablePuzzleModal();
                        }, 1000);
                    }
                    else {
                        result!.textContent = "❌ Incorrect. Try again.";
                        this.selections = {};
                        buttons.forEach(b => (b as HTMLElement).classList.remove("selected"));
                        setTimeout(() => {
                            result!.textContent = "";
                            this.locked = false;
                        }, 1000);
                    }
                }
            });
        });

        const closeBtn: Element | null | undefined = this.shadowRoot?.querySelector("#close-btn");
        closeBtn?.addEventListener("click", () => {
            CablePuzzleModal.closeCablePuzzleModal();
        });
    }
};
